import { Slide, SlideProps } from "@mui/material";

export const SlideTransition = (props: SlideProps) => {
  return <Slide {...props} direction="left" />;
};
